import { render, staticRenderFns } from "./financialOther.vue?vue&type=template&id=92bec41c&scoped=true"
var script = {}
import style0 from "./financialOther.vue?vue&type=style&index=0&id=92bec41c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bec41c",
  null
  
)

export default component.exports